import { AxiosResponse } from "axios";
import { stockTypes } from "../../types/stockTypes";
import { PaginationResponse, StatusResponse } from "../../types/type";
import Api from "../api";
import { CATEGORY_STOCK, STOCK_DETAILS } from "../endpoint";

type FilterValue = {

    value: string[];
};

type Filters = {
    [key: string]: FilterValue;
};


export const getListOfStock = async (page: number, rows: number, filter: Filters | undefined, searchTerm: string = ""): Promise<{
    status: StatusResponse,
    data: stockTypes[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,

        page: page, offSet: page,
        filters: filter,
        searchTerm: searchTerm,
    }
    try {
        const response: AxiosResponse<{
            status: StatusResponse,
            data: stockTypes[],
            pagination: PaginationResponse
            //}> = await Api.get(`${STOCK_DETAILS}?page=${page}&limit=${rows}`);
        }> = await Api.post(`${STOCK_DETAILS}/filter`, payload);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(`Error in Get list of Asset with status code:${response.status}`);
        }
    } catch (err) {
        throw err;
    }
}

interface StockCodeCategoryResponse {
    status: StatusResponse;
    data: {
        stockCodeId: number;
        stock_code: string;
        stock_description: string;
        current_stock: number;
    }[];
}
export const getStockCodesByCategory = async (
    stockCategory: string
): Promise<StockCodeCategoryResponse> => {
    try {
        const payload = { stockCategory };

        const response: AxiosResponse<StockCodeCategoryResponse> = await Api.post(
            CATEGORY_STOCK,
            payload
        );

        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(`Error fetching stock codes by category: ${response.status}`);
        }
    } catch (err) {
        console.error("❌ Error in getStockCodesByCategory:", err);
        throw err;
    }
};


export const getListOfStockTransfer = async (page: number, rows: number, filter: Filters | undefined, searchTerm: string = ""): Promise<{
    status: StatusResponse,
    data: any[],
    pagination: PaginationResponse
}> => {
    const payload = {
        limit: rows,

        page: page, offSet: page,
        filters: filter,
        searchTerm: searchTerm,
    }
    try {
        const response: AxiosResponse<{
            status: StatusResponse,
            data: any[],
            pagination: PaginationResponse
            //}> = await Api.get(`${STOCK_DETAILS}?page=${page}&limit=${rows}`);
        }> = await Api.post(`${STOCK_DETAILS}/transactions`, payload);
        if (response.status === 200) {
            return response.data;
            console.log(response.data);

        } else {
            throw new Error(`Error in Get list of Asset with status code:${response.status}`);
        }
    } catch (err) {
        throw err;
    }
}



export const deleteStockDetails = async (stockId: number) => {
    try {
        const response = await Api.delete(`${STOCK_DETAILS}/${stockId}`);
        if (response.status === 204) {
            return response;
        } else {
            throw new Error(`Error in delete data by id of Stock with status code:${response.status}`);
        }
    } catch (err) {
        throw err;
    }
}

export const createStockData = async (payload: stockTypes): Promise<{ status: StatusResponse, data: any }> => {
    try {
        const response: AxiosResponse<{ status: StatusResponse, data: any }> = await Api.post(STOCK_DETAILS, payload);
        if (response.status === 200 || response.status == 201) {
            return response.data;
        } else {
            throw new Error(`Create Asset Request failed with status code:${response.status}`);
        }
    } catch (err) {
        throw err;
    }
}

export const updateStockData = async (payload: stockTypes): Promise<{ status: StatusResponse, data: any }> => {
    try {
        const response: AxiosResponse<{ status: StatusResponse, data: any }> = await Api.put(STOCK_DETAILS, payload);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(`Update Asset Request failed with status code:${response.status}`);
        }
    } catch (err) {
        throw err;
    }
}

export const getStockByIdData = async (stockId: number): Promise<{
    status: StatusResponse,
    data: stockTypes
}> => {
    try {
        const response: AxiosResponse<{
            status: StatusResponse,
            data: stockTypes,
        }> = await Api.get(`${STOCK_DETAILS}/${stockId}`);
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error(`Error in Get data by id of Asset with status code:${response.status}`);
        }
    } catch (err) {
        throw err;
    }
}
